import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import NewsEvent from "../../../containers/modules/news/news-event";

export default function AcceptanceReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="acceptance-report"
      index
      element={
        <AccessControl
          name={"News Event List"}
          auth={authUser}
          component={() => <NewsEvent />}
        />
      }
    ></Route>
  );
}
